/**
 * gameCode : lin, lin2, aion, bns, bnsr(프론티어 서버)
 * 
 * import NcoinGift from "./NcoinGift";
 * window.ncoinGiftPopup = new NcoinGift({wstatic:'https://wstatic-cdn.plaync.com', isLogin: true});
 * 
 * // 선물하기 클릭시
 * window.ncoinGiftPopup.open( {gameCode}, {serverId}, {characterName} );
 * // 쿠폰틍록 클릭시
 * window.ncoinGiftPopup.openCouponPop();
*/

class NcoinGift {
    constructor(_config){
        this.wstatic = _config.wstatic;
        this.isLogin = _config.isLogin;
    }

    open(_serverId, _characterName){
        if(!this.isLogin){
            window.GNBLogin();
            return false;
        }
        
        if(!userData.representativeCharacter.name){
            if(confirm('대표 캐릭터 설정 후 N코인 선물하기가 가능합니다.')){
                window.cnb.openCharacterPan();
            }
            return false;
        }
      const shopURL = this.wstatic.indexOf('rc-assets') > -1 ? 'https://rc-store.plaync.com/wallet/coin/gift' : 'https://store.plaync.com/wallet/coin/gift';
      window.open(`${shopURL}?gameCode=bnsr&serverId=${_serverId}&characterName=${encodeURI(_characterName)}`, '_blank', 'width=480, height=720');
    }



} // end of class
export default NcoinGift;

/* 
* N샵 팝업
N샵 공통 Popup Guide: https://wiki.ncsoft.com/display/PTG/v0.0.4

// JS import
<script src="HOST/nshop/common/popup/dist/js/popup-0.0.4-min.js"></script>
nshop.popup({ popup_service:"nshop_coupon"})
nshop.popup({ popup_service:"NSHOP_GIFT", param: {"TEST_userID":"JOHN_guest1", "TEST_PARAM":"FOOBAR"} })
*/